import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import { getOpenCommissions, submitPitch } from '../services/api';
import { useAuth } from '../services/AuthContext';

function CommissionBoard() {
  const [commissions, setCommissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const { vendor } = useAuth();
  const [pitchModal, setPitchModal] = useState(null);
  const [pitchForm, setPitchForm] = useState({ message: '', price: '', estimatedDays: '' });
  const [enlargedImg, setEnlargedImg] = useState(null);

  useEffect(() => {
    getOpenCommissions().then(data => setCommissions(data.commissions || [])).catch(() => {}).finally(() => setLoading(false));
  }, []);

  async function handlePitch(e) {
    e.preventDefault();
    try {
      await submitPitch(pitchModal, { message: pitchForm.message, price: Math.round(parseFloat(pitchForm.price) * 100), estimatedDays: parseInt(pitchForm.estimatedDays) });
      setPitchModal(null);
      setPitchForm({ message: '', price: '', estimatedDays: '' });
      const data = await getOpenCommissions();
      setCommissions(data.commissions || []);
    } catch (err) { alert(err.error || 'Failed to submit pitch'); }
  }

  if (loading) return <div className="workshop-page"><Header /><p style={{padding:'8rem 2rem',textAlign:'center'}}>Loading...</p></div>;

  return (
    <div className="workshop-page">
      <Header />
      <div className="workshop-content">
        <h1 className="workshop-title">🎯 Commission Board</h1>
        <p className="workshop-subtitle">Customers looking for custom work — pitch your skills</p>

        <div className="commissions-board-grid">
          {commissions.length === 0 && <p className="empty-state">No open commissions right now. Check back soon!</p>}
          {commissions.map(c => (
            <div className="commission-board-card" key={c.commissionId}>
              <div className="commission-card-header">
                <h3>{c.title}</h3>
                {c.budget && <span className="commission-budget">{c.budget}</span>}
              </div>
              {c.inspirationImages && c.inspirationImages.length > 0 && (
                <div className="commission-ref-photos">
                  {c.inspirationImages.map((url, i) => <img key={i} src={url} alt="Reference" onClick={() => setEnlargedImg(url)} style={{cursor:'pointer'}} />)}
                </div>
              )}
              <p className="commission-desc">{c.description}</p>
              <div className="commission-meta">
                {c.timeline && <span>⏱ {c.timeline}</span>}
                {c.woodSpecies && <span>🪵 {c.woodSpecies}</span>}
                {c.dimensions && <span>📐 {c.dimensions}</span>}
              </div>
              <div className="commission-card-footer">
                <span className="commission-pitches">{c.pitchCount || 0} pitch{c.pitchCount !== 1 ? 'es' : ''}</span>
                <span className="commission-date">{new Date((c.createdAt || 0) * 1000).toLocaleDateString()}</span>
              </div>
              {vendor && (c.pitchCount || 0) < 10 && (
                <button className="btn-primary" style={{marginTop:'0.75rem', width:'100%'}} onClick={() => setPitchModal(c.commissionId)}>Submit a Pitch</button>
              )}
              {(c.pitchCount || 0) >= 10 && <p className="commission-maxed">Max pitches reached</p>}
            </div>
          ))}
        </div>

        {pitchModal && (
          <div className="item-form-overlay">
            <div className="item-form">
              <h3>🎯 Submit Your Pitch</h3>
              <p className="settings-hint">Tell the customer why you're the right fit. Be specific about your approach.</p>
              <form onSubmit={handlePitch}>
                <textarea placeholder="Your pitch — describe your approach, materials, experience... *" value={pitchForm.message} onChange={e => setPitchForm({...pitchForm, message: e.target.value})} rows={4} required />
                <input type="number" step="0.01" placeholder="Your price ($) *" value={pitchForm.price} onChange={e => setPitchForm({...pitchForm, price: e.target.value})} required />
                <input type="number" placeholder="Estimated days to complete *" value={pitchForm.estimatedDays} onChange={e => setPitchForm({...pitchForm, estimatedDays: e.target.value})} required />
                <div className="form-buttons">
                  <button type="submit" className="btn-primary">Submit Pitch</button>
                  <button type="button" className="btn-secondary" onClick={() => setPitchModal(null)}>Cancel</button>
                </div>
              </form>
            </div>
          </div>
        )}

        {enlargedImg && (
          <div className="lightbox-overlay" onClick={() => setEnlargedImg(null)}>
            <img src={enlargedImg} alt="Reference" style={{maxWidth:'90vw', maxHeight:'85vh', objectFit:'contain', borderRadius:'8px'}} />
          </div>
        )}
      </div>
    </div>
  );
}

export default CommissionBoard;
